module.exports = __webpack_public_path__ + "static/media/brian.86f44d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brian.jpg
// module id = 70
// module chunks = 0